// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p0-0";
export var discountCodeInput = "_p0-1";